var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortlistRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "shortlist-remove_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".shortlist-remove_svg__cls-2{fill:#01346b}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shortlist-remove_svg__Group_33759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shortlist-remove_svg__Group_32888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shortlist-remove_svg__Ellipse_338"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none",
    stroke: "#191919",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "shortlist-remove_svg__Icon_ionic-ios-heart-empty",
    className: "shortlist-remove_svg__cls-2",
    d: "M30.13 15.59h-.06c-2.1.01-4.06 1.08-5.2 2.85a6.222 6.222 0 00-5.2-2.85h-.06c-3.4.03-6.13 2.79-6.13 6.19.14 2.63 1.05 5.16 2.62 7.27 2.54 3.19 5.49 6.04 8.77 8.45 3.29-2.41 6.24-5.26 8.77-8.45 1.57-2.11 2.48-4.64 2.62-7.27 0-3.4-2.74-6.16-6.13-6.19zm-10.5 1.54H30.1s-11.7.01-10.47 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "shortlist-remove_svg__Icon_ionic-ios-heart-empty-2",
    className: "shortlist-remove_svg__cls-2",
    d: "M30.13 15.59h-.06c-2.1.01-4.06 1.08-5.2 2.85a6.222 6.222 0 00-5.2-2.85h-.06c-3.4.03-6.13 2.79-6.13 6.19.14 2.63 1.05 5.16 2.62 7.27 2.54 3.19 5.49 6.04 8.77 8.45 3.29-2.41 6.24-5.26 8.77-8.45 1.57-2.11 2.48-4.64 2.62-7.27 0-3.4-2.74-6.16-6.13-6.19zm2.28 12.55a42.367 42.367 0 01-7.53 7.43 42.035 42.035 0 01-7.53-7.43 11.829 11.829 0 01-2.32-6.36c0-2.55 2.06-4.63 4.61-4.65h.05c.79 0 1.56.2 2.25.59.67.38 1.24.91 1.66 1.56a1.535 1.535 0 002.57 0c.42-.65.99-1.18 1.66-1.56.69-.39 1.46-.59 2.25-.59h.05c2.55.02 4.61 2.1 4.61 4.65-.15 2.3-.96 4.51-2.33 6.36z"
  })))));
}

export default __webpack_public_path__ + "5098b51aae0ab99eb2c15cf8a9d15089.svg";
export { SvgShortlistRemove as ReactComponent };